// CompareLayout.js
// Shared chrome for CompareIndex and CompareArticle: slim top bar with the TTO
// wordmark (links home) and a content container. Mirrors GuidesLayout so the
// Compare section reads as the same site.

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { colors } from './compareData';

export default function CompareLayout({ children, maxWidth = 760 }) {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: colors.gray50, color: colors.gray800 }}>
      <header
        style={{
          background: 'white',
          borderBottom: `1px solid ${colors.gray200}`,
          padding: '12px 20px',
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }}
      >
        <div
          style={{
            maxWidth: 1100,
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'baseline', gap: 10 }}
          >
            <span
              style={{ fontSize: 20, fontWeight: 800, color: colors.gray900, letterSpacing: '-0.5px' }}
            >
              Tee Time Organizer
            </span>
            <span style={{ fontSize: 12, color: colors.gray500, fontWeight: 500 }}>Compare</span>
          </div>
          <button
            onClick={() => navigate('/register?tier=free')}
            style={{
              background: `linear-gradient(135deg, ${colors.green700} 0%, ${colors.green900} 100%)`,
              color: 'white',
              border: 'none',
              borderRadius: 8,
              padding: '9px 16px',
              fontSize: 14,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Try it free
          </button>
        </div>
      </header>

      <main style={{ maxWidth, margin: '0 auto', padding: '32px 20px 64px' }}>{children}</main>

      <footer
        style={{
          background: colors.gray900,
          color: colors.gray300,
          padding: '28px 20px',
          textAlign: 'center',
          fontSize: 13,
        }}
      >
        <div style={{ marginBottom: 10 }}>
          <span
            onClick={() => navigate('/')}
            style={{ color: colors.gray300, cursor: 'pointer', margin: '0 10px' }}
          >
            Home
          </span>
          <span
            onClick={() => navigate('/compare')}
            style={{ color: colors.gray300, cursor: 'pointer', margin: '0 10px' }}
          >
            All Comparisons
          </span>
          <span
            onClick={() => navigate('/guides')}
            style={{ color: colors.gray300, cursor: 'pointer', margin: '0 10px' }}
          >
            Guides
          </span>
        </div>
        <div style={{ color: colors.gray500 }}>
          © 2025–2026 Tee Time Organizer. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
